var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useRouter } from "next/router";
import getUnixTime from "date-fns/getUnixTime";
import { sha1 } from "crypto-hash";
import { useAuth0 } from "@auth0/auth0-react";
var fieldNamesToEncrypt = [
    "password",
    "passwordConfirmation",
    "EIN",
    "sSNumber",
];
var getValueAndNameFromHTMLInputElement = function (target) {
    return { name: target.name, value: target.value };
};
var encryptValueOrPassthrough = function (name, value) {
    if (fieldNamesToEncrypt.includes(name)) {
        return sha1(value);
    }
    return value;
};
var trackPostBody = function (dropoff, lastTouchedField, lastTouchedFieldValue, applicationMaybe) {
    return {
        _v: 1,
        u: dropoff.Auth0UserId,
        t: getUnixTime(new Date()),
        p: dropoff.page,
        f: lastTouchedField,
        v: encryptValueOrPassthrough(lastTouchedField, lastTouchedFieldValue.toString()),
        i: [],
        a: applicationMaybe === null || applicationMaybe === void 0 ? void 0 : applicationMaybe.app.id,
        l: applicationMaybe === null || applicationMaybe === void 0 ? void 0 : applicationMaybe.app.new_leadID,
    };
};
export var trackFieldDropoff = function (dropoff, lastTouchedField, lastTouchedFieldValue, applicationMaybe) {
    if (lastTouchedField !== "") {
        fetch("/api/fieldLevelDropoff", {
            method: "post",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(trackPostBody(dropoff, lastTouchedField, lastTouchedFieldValue, applicationMaybe)),
        });
    }
};
export var onBlurTrackFieldDropoff = function (e, dropoff, applicationMaybe) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, name_1, value;
    return __generator(this, function (_b) {
        if (e.target instanceof HTMLInputElement ||
            e.target instanceof HTMLSelectElement ||
            e.target instanceof HTMLButtonElement ||
            e.target instanceof HTMLTextAreaElement) {
            _a = getValueAndNameFromHTMLInputElement(e.target), name_1 = _a.name, value = _a.value;
            trackFieldDropoff(dropoff, name_1, value, applicationMaybe);
        }
        return [2 /*return*/];
    });
}); };
export var useVariablesForFieldTracking = function () {
    var user = useAuth0().user;
    var Auth0UserId = user === null || user === void 0 ? void 0 : user.sub;
    var router = useRouter();
    var page = router.pathname;
    return {
        Auth0UserId: Auth0UserId,
        page: page,
    };
};
//# sourceMappingURL=data:application/json;base64,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